import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { motion } from "framer-motion";

const AboutMeSection = () => {
  return (
    <div>
      <Navbar />

      <div className="container mx-auto px-6 py-16 space-y-16">
        {/* HERO INTRO */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center max-w-3xl mx-auto"
        >
          <h1 className="text-4xl font-bold text-green-700 mb-4">
            About the Founder
          </h1>
          <p className="text-gray-600 text-lg">
            Building clean, reliable and affordable solar energy solutions for
            homes and businesses in Nigeria.
          </p>
        </motion.div>

        {/* MAIN GRID */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          {/* LEFT - STORY */}
          <motion.div
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            className="space-y-6"
          >
            <h2 className="text-2xl font-bold">About Me</h2>

            <p className="text-gray-700 leading-relaxed">
              Hello! I’m Damilare. Over the years, I’ve seen how confusing and
              overwhelming it can be for homeowners and businesses to navigate
              solar energy.
            </p>

            <p className="text-gray-700 leading-relaxed">
              That’s why I built a system that simplifies everything — from
              solar panel installations to batteries and accessories, with
              transparent estimates so you know exactly what you’re paying for.
            </p>

            <p className="text-gray-700 leading-relaxed">
              As a licensed electrician with a background in electrical and
              mechanical maintenance, I bring both technical expertise and
              hands-on field experience to every project.
            </p>

            {/* IMAGE BLOCK (FIXED SIZE) */}
            <motion.div
              whileHover={{ scale: 1.02 }}
              className="rounded-2xl overflow-hidden shadow-lg border"
            >
              <img
                src="/Assets/batteryy.webp"
                alt="DIY Battery"
                className="w-full h-[260px] object-cover"
              />
              <p className="text-sm text-center text-gray-600 p-3">
                DIY 12V LiFePO4 battery with BMS, Fuse, and Shunt
              </p>
            </motion.div>
          </motion.div>

          {/* RIGHT - FOUNDER CARD */}
          <motion.div
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            whileHover={{ scale: 1.02 }}
            className="bg-white rounded-3xl shadow-xl overflow-hidden border"
          >
            {/* IMAGE (CONTROLLED HEIGHT FIX) */}
            <div className="relative">
              <img
                src="/Assets/Odedeyi.jpeg"
                alt="Founder"
                className="w-full h-[420px] object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
            </div>

            {/* CONTENT */}
            <div className="p-6 space-y-4">
              <h3 className="text-xl font-semibold">
                Welcome to Solaris Surge
              </h3>

              <p className="text-gray-700 leading-relaxed">
                I’m the driving force behind this platform, focused on making
                renewable energy accessible, affordable, and tailored to
                real-world needs.
              </p>

              <p className="text-gray-700 leading-relaxed">
                Every day, we help homeowners and businesses transition into
                clean energy systems that are reliable and cost-efficient.
              </p>

              {/* MINI STATS */}
              <div className="grid grid-cols-3 gap-3 pt-4">
                <div className="text-center p-3 bg-green-50 rounded-xl">
                  <p className="text-green-700 font-bold">100+</p>
                  <p className="text-xs text-gray-600">Installations</p>
                </div>

                <div className="text-center p-3 bg-green-50 rounded-xl">
                  <p className="text-green-700 font-bold">5★</p>
                  <p className="text-xs text-gray-600">Client Rating</p>
                </div>

                <div className="text-center p-3 bg-green-50 rounded-xl">
                  <p className="text-green-700 font-bold">24/7</p>
                  <p className="text-xs text-gray-600">Support</p>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>

      {/* WHATSAPP FLOAT */}
      <a
        href="https://wa.me/+2348165213568?text=Hi!%20I%20have%20a%20query."
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-4 right-4 bg-green-500 p-3 rounded-full shadow-lg hover:scale-110 transition"
      >
        <img src="/Assets/chat.png" alt="WhatsApp Chat" className="w-8 h-8" />
      </a>

      <Footer />
    </div>
  );
};

export default AboutMeSection;
